export const getStatusInfo = (record) => {
  const { collection_status, payment_status, posting_status = 0, paidByCheque } = record || {};
  
  let statusText;
  let backgroundColor;
  let color = "black";

  if (payment_status >= 2) {
    if (posting_status === 2 && collection_status === 1) {
      statusText = "Success";
      backgroundColor = "rgba(193, 221, 117, 0.30)";
    } else if (posting_status === 1) {
      statusText = "Processing";
      backgroundColor = "rgba(255, 165, 0, 0.30)";
    } else {
      statusText = "Pending";
      backgroundColor = "rgba(214, 162, 67, 0.30)";
    }
  } else if (payment_status === 0) {
    statusText = "UPI Pending";
    backgroundColor = "rgba(255, 202, 0, 0.30)";
  } else {
    statusText = paidByCheque ? "Cheque Rejected" : "UPI Failed";
    backgroundColor = "rgba(255, 0, 0, 0.15)";
  }

  return { statusText, backgroundColor, color };
};
